<template>
  <div>
    <div v-if="model">
      <div class="main-content" :class="error ? ['error'] : []">
        <div class="main-content-heading">
          <h1>Dotazník štýlov učenia</h1>
          <div class="back">
             <router-link :to="{name: 'questionary_all'}">&lt; Späť na dotazníky</router-link>
          </div>
        </div>
        <div class="heading-spliter"></div>
        <div
          class="text-mute"
        >Dotazník štýlov učenia zisťuje, akému prístupu dávate prednosť pri učení. Rokmi si každý z nás vytvorí v učení návyky, ktoré nám umožňujú mať väčší prospech z jednej skúsenosti než z inej. Túto skutočnosť si neuvedomuje každý. Tento dotazník určuje, čomu dávate pri učení prednosť Vy. 
        <br><br>
        Vyplňovanie dotazníka nie je časovo obmedzené, približne trvá 10-15 minút. Presnosť a správnosť výsledkov závisí od toho, ako úprimne dokážete odpovedať. V dotazníku nie sú správne a nesprávne odpovede.
        <br><br>
          <b>Inštrukcia</b>
          <br><br>
          Dotazník vyplňujte nasledovne. Prečítajte si tvrdenie, rozhodnite sa,  nakoľko s ním súhlasíte.
           Ak s tvrdením viac súhlasíte ako nesúhlasíte, zakliknite “<b>súhlasím</b>“. Ak s výrokom viac nesúhlasíte ako súhlasíte, zakliknite “<b>nesúhlasím</b>“. 
  <br><br>
  Po skončení sa presvedčte, či ste ohodnotili každé tvrdenie.
  </div>
        <h2>{{model.questionary.lang.name}}</h2>
        <div class="main-content-box result" v-if="model.result && !model.questionary.hidden_results">
          <div class="left">Váš výsledok</div>
          <div class="right">
            <div class="finished">
              <div class="item">A: {{model.result.A}}</div>
              <div class="item">R: {{model.result.R}}</div>
              <div class="item">T: {{model.result.T}}</div>
              <div class="item">P: {{model.result.P}}</div>
              <div class="item hide_mobile_flex">
                <a
                  style="color: inherit; text-transform: none;"
                  target="_blank"
                  :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
                >
                  <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
                </a>
              </div>
            </div>
            <div class="finished show_mobile_flex">
              <a
                style="color: inherit; text-transform: none;"
                target="_blank"
                :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
              >
                <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
              </a>
            </div>
          </div>
        </div>
        <div v-for="question in questionModel" class="main-content-box ls">
          <div class="left">
            <label
              :class="question.model === null ? ['empty'] : ['filled']"
            >{{question.question.text}}</label>
          </div>

          <div class="right" style="flex-direction: row;">
            <span class="cel" style="width: 90px; margin-right: 25px;">
              <input
                :disabled="!!model.result"
                type="radio"
                :id="'ls_question_' + question.question.local_id+ '_y'"
                value="0"
                v-model="question.model"
                @change="saveQuestion(question)"
              />
              <label :for="'ls_question_' + question.question.local_id+ '_y'">Súhlasím</label>
            </span>
            <span class="cel" style=" width: 95px;">
              <input
                :disabled="!!model.result"
                type="radio"
                :id="'ls_question_' + question.question.local_id+ '_no'"
                value="1"
                v-model="question.model"
                @change="saveQuestion(question)"
              />
              <label :for="'ls_question_' + question.question.local_id + '_no'">Nesúhlasím</label>
            </span>
          </div>
        </div>
        <div class="bottom-buttons">
          <a v-if="!model.result" @click="close" class="button">Odoslať dotazník ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormBase from "../../elements/FormBase";
import { required, email } from "vuelidate/lib/validators";
import RangeSlider from "vue-range-slider";
import Vue from "vue";
import _ from "lodash";
import server from "../../api/server";
export default {
  components: {
    RangeSlider
  },
  mixins: [FormBase],
  props: ["model"],
  data() {
    return {
      questionModel: null,
      error: false,
      pdfUrl: server.baseUrl,
      savedQuestions: [],
      timeout: null
    };
  },
  mounted() {},
  created() {
    this.timeout = setInterval(() => {
      this.save();
    }, 2500);
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    changeVal(question, e) {
      this.$forceUpdate();
    },
    saveQuestion(question) {
      this.$forceUpdate();
      this.savedQuestions.push({
        id: this.model.id,
        lang_id: this.$api.translator.getCurrent(),
        local_id: question.question.local_id,
        value: question.model
      });
    },
    save() {
      if (this.savedQuestions.length > 0) {
        this.$forceUpdate();
        let q = this.savedQuestions;
        this.savedQuestions = [];
        this.$api.server
          .post("api/public/questionary/questions/save_all", {
            arr: JSON.stringify(q)
          })
          .then(r => {
            this.$api.bus.trigger(
              "course-status-change",
              this.model.id,
              r.data.progress
            );
          })
          .catch(() => {
            alert("Chyba pri ukladaní dát. Obnovte stránku prosím.");
          });
      }
    },
    check() {
      return true;
    },
    close() {
      var self = this;
      if (!this.check()) {
        self.$api.toaster.fail({ txt: "Vyplnte všetky polia" });
        return;
      }
      this.save();
      this.$api.bus.trigger("open-modal", {
        header: "Odoslať dotazník na hodnotenie ?",
        message: "Odoslať dotazník na hodnotenie ?",
        okBtn: "Áno",
        closeBtn: "Nie",
        cb() {
          self.$api.server
            .post("api/public/questionary/questions/close", {
              id: self.model.id,
              lang_id: self.$api.translator.getCurrent()
            })
            .then(r => {
              if (r.data.result) {
                window.location.reload();
              } else {
                self.$api.toaster.fail({
                  txt: "Vyplňte prosím všetky otázky."
                });
                self.error = true;
              }
            });
        }
      });
    }
  },
  computed: {},
  watch: {
    model: {
      handler() {
        if (!this.model) return;
        this.questionModel = [];
        var self = this;
        for (var i in this.model.questions) {
          //this.model.questions[i] = new Vue({data:()=>{return {...self.model.questions[i]};}});
          this.questionModel[i] = new Vue({
            data: () => {
              return { ...self.model.questions[i] };
            }
          });
          this.questionModel[i].model = this.model.questions[i].result
            ? this.model.questions[i].result.value
            : null;
        }
      },
      immediate: true,
      deep: false
    }
  },
  validations() {}
};
</script>
<style lang="css">
.center .range-slider {
  width: 90%;
}
.center {
  text-align: center;
}

a {
  cursor: pointer;
}
.center.disabled .range-slider-fill {
  width: 0px !important;
}
.main-content .ls .right .cel {
  font-weight: normal;
  display: inline-flex;
  align-items: center;
  flex-direction: row-reverse;
}

.main-content .ls .right .cel input {
  display: inline-block;
  float: right;
}
.main-content .ls .right .cel label {
  display: inline-block;
  float: left;
}

.main-content .ls .right .cel input[type="radio"]:checked + label {
  font-weight: bold;
}

.left .empty {
  font-weight: bold;
}

.error .left .empty {
  color: red;
  font-weight: bold;
}

.left .filled {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/questionary/LsForm.vue